<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span class="toolbar-title">{{
    isNew ? "Nueva plantilla" : template.name
  }}</span>
  <span class="toolbar-spacer"></span>
  @if (!isNew) {
    <button
      mat-icon-button
      [matMenuTriggerFor]="actionsMenu"
      matTooltip="Más acciones"
    >
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #actionsMenu="matMenu">
      <button mat-menu-item (click)="openTestSendDialog()">
        <mat-icon>send</mat-icon>
        <span>Envío de prueba</span>
      </button>
      <button mat-menu-item (click)="resetDefaults()">
        <mat-icon>restore</mat-icon>
        <span>Restaurar por defecto</span>
      </button>
    </mat-menu>
  }
</mat-toolbar>

<block-ui>
  <div class="edit-page">
    @if (template) {
      <form #templateForm="ngForm" (ngSubmit)="save(templateForm)" novalidate>
        <!-- ─ Sección: Info general ──────────── -->
        <section class="edit-section">
          <h2 class="edit-section__title">Información general</h2>
          <div class="edit-row edit-row--2">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                matInput
                name="name"
                [(ngModel)]="template.name"
                required
                maxlength="120"
              />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Clave (key)</mat-label>
              <input
                matInput
                name="key"
                [(ngModel)]="template.key"
                required
                pattern="[a-z0-9_\-]+"
                [disabled]="!isNew"
              />
              <mat-hint>Sólo minúsculas, números, guiones y _</mat-hint>
            </mat-form-field>
          </div>

          <div class="edit-row edit-row--2">
            <mat-form-field appearance="outline">
              <mat-label>Categoría</mat-label>
              <input
                matInput
                name="category"
                [(ngModel)]="template.category"
                required
              />
            </mat-form-field>

            <div class="toggle-field">
              <mat-slide-toggle
                name="enabled"
                [(ngModel)]="template.enabled"
                color="primary"
              >
                Plantilla activa
              </mat-slide-toggle>
            </div>
          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Descripción</mat-label>
            <textarea
              matInput
              name="description"
              [(ngModel)]="template.description"
              rows="2"
              maxlength="300"
            ></textarea>
          </mat-form-field>
        </section>

        <!-- ─ Sección: Asunto ───────────────── -->
        <section class="edit-section">
          <h2 class="edit-section__title">Asunto</h2>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Asunto del email</mat-label>
            <input
              matInput
              name="subjectTemplate"
              [(ngModel)]="template.subjectTemplate"
              required
            />
            <mat-hint
              >Puedes usar variables como
              <code>{{ '{{username}}' }}</code></mat-hint
            >
          </mat-form-field>
        </section>

        <!-- ─ Sección: Destinatarios ─────────── -->
        <section class="edit-section">
          <h2 class="edit-section__title">Destinatarios adicionales</h2>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Para (To)</mat-label>
            <input
              matInput
              name="recipientsTo"
              [ngModel]="template.recipients.to?.join(', ')"
              (ngModelChange)="setRecipients('to', $event)"
              placeholder="email1@dominio.com, email2@dominio.com"
            />
            <mat-hint>Separados por coma. Opcional.</mat-hint>
          </mat-form-field>

          <div class="edit-row edit-row--2">
            <mat-form-field appearance="outline">
              <mat-label>CC</mat-label>
              <input
                matInput
                name="recipientsCc"
                [ngModel]="template.recipients.cc?.join(', ')"
                (ngModelChange)="setRecipients('cc', $event)"
              />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>BCC</mat-label>
              <input
                matInput
                name="recipientsBcc"
                [ngModel]="template.recipients.bcc?.join(', ')"
                (ngModelChange)="setRecipients('bcc', $event)"
              />
            </mat-form-field>
          </div>
        </section>

        <!-- ─ Sección: Variables ─────────────── -->
        <section class="edit-section">
          <h2 class="edit-section__title">Variables permitidas</h2>
          <div class="variables-wrap">
            @for (v of template.allowedVariables; track $index) {
              <mat-chip class="variable-chip">
                <code>{{ "{​{" + v + "}​}" }}</code>
                <button
                  matChipRemove
                  type="button"
                  (click)="removeVariable($index)"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            }
          </div>
          <div class="variable-add-row">
            <mat-form-field appearance="outline" class="variable-input">
              <mat-label>Nueva variable</mat-label>
              <input
                matInput
                [(ngModel)]="newVariable"
                name="newVariable"
                (keydown.enter)="addVariable(); $event.preventDefault()"
              />
            </mat-form-field>
            <button mat-stroked-button type="button" (click)="addVariable()">
              <mat-icon>add</mat-icon> Añadir
            </button>
          </div>
        </section>

        <!-- ─ Sección: HTML ─────────────────── -->
        <section class="edit-section">
          <h2 class="edit-section__title">Cuerpo HTML</h2>
          <div class="editor-wrap">
            <editor
              apiKey="kt6pgrepxvoc0ybgjgvvrx4hjrcp897kb9195e330z82vzd8"
              name="htmlTemplate"
              [(ngModel)]="template.htmlTemplate"
              [init]="tinymceConfig"
            >
            </editor>
          </div>
        </section>

        <!-- ─ Sección: Texto plano ───────────── -->
        <section class="edit-section">
          <h2 class="edit-section__title">
            Cuerpo texto plano <span class="optional-label">(opcional)</span>
          </h2>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Versión texto plano</mat-label>
            <textarea
              matInput
              name="textTemplate"
              [(ngModel)]="template.textTemplate"
              rows="6"
            ></textarea>
          </mat-form-field>
        </section>

        <!-- ─ Acciones ───────────────────────── -->
        <div class="edit-actions">
          <button mat-button type="button" (click)="goBack()">Cancelar</button>
          @if (!isNew) {
            <button
              mat-stroked-button
              type="button"
              (click)="previewTemplate()"
            >
              <mat-icon>preview</mat-icon>
              Vista previa
            </button>
          }
          <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="templateForm.invalid"
          >
            <mat-icon>save</mat-icon>
            Guardar
          </button>
        </div>
      </form>
    }
  </div>
</block-ui>

<!-- ─ Dialog preview ──────────────────────────── -->
@if (previewHtml) {
  <div class="preview-overlay" (click)="closePreview()">
    <div class="preview-dialog" (click)="$event.stopPropagation()">
      <div class="preview-dialog__header">
        <strong>Asunto:</strong> {{ previewSubject }}
        <button mat-icon-button (click)="closePreview()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <iframe
        class="preview-dialog__frame"
        [srcdoc]="previewHtml"
        sandbox="allow-same-origin"
      ></iframe>
    </div>
  </div>
}

<!-- ─ Dialog test send ───────────────────────── -->
@if (showTestSendDialog) {
  <div class="preview-overlay" (click)="showTestSendDialog = false">
    <div
      class="preview-dialog preview-dialog--sm"
      (click)="$event.stopPropagation()"
    >
      <div class="preview-dialog__header">
        <strong>Envío de prueba</strong>
        <button mat-icon-button (click)="showTestSendDialog = false">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="preview-dialog__body">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email destinatario</mat-label>
          <input matInput [(ngModel)]="testSendEmail" type="email" />
        </mat-form-field>
        <div class="preview-dialog__actions">
          <button mat-button (click)="showTestSendDialog = false">
            Cancelar
          </button>
          <button mat-flat-button color="primary" (click)="sendTestEmail()">
            Enviar
          </button>
        </div>
      </div>
    </div>
  </div>
}
